var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrophy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4444 3.11111H21.7778V1.55556C21.7778 0.696446 21.0813 0 20.2222 0H7.77778C6.91867 0 6.22222 0.696446 6.22222 1.55556V3.11111H1.55556C0.696446 3.11111 0 3.80756 0 4.66667V10.8889C0 14.3253 2.78578 17.1111 6.22222 17.1111H6.44C7.14744 19.8511 9.61465 21.7686 12.4444 21.7778V28H8.55556C8.126 28 7.77778 28.3482 7.77778 28.7778V30.3333C7.77778 30.7629 8.126 31.1111 8.55556 31.1111H19.4444C19.874 31.1111 20.2222 30.7629 20.2222 30.3333V28.7778C20.2222 28.3482 19.874 28 19.4444 28H15.5556V21.7778C18.3854 21.7686 20.8526 19.8511 21.56 17.1111H21.7778C25.2142 17.1111 28 14.3253 28 10.8889V4.66667C28 3.80756 27.3036 3.11111 26.4444 3.11111ZM3.11133 10.8893V6.22266H6.22244V14.0004C4.50422 14.0004 3.11133 12.6075 3.11133 10.8893ZM21.7773 14.0004C23.4956 14.0004 24.8885 12.6075 24.8885 10.8893V6.22266H21.7773V14.0004Z",
    fill: "#05C1FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.02ada88d.svg";
export { ForwardRef as ReactComponent };